import type { PickActionFromState, Dispatch } from '~/utils/redux';
import type { DishesState, MenuItemSource } from './DishesState';

export const OPEN_MENU_ITEM_MODAL = 'OPEN_MENU_ITEM_MODAL';
export const CLOSE_MENU_ITEM_MODAL = 'CLOSE_MENU_ITEM_MODAL';

export type DishesAction =
  CloseMenuItemModalAction |
  OpenMenuItemModalAction;

type OpenMenuItemModalAction = PickActionFromState<DishesState, typeof OPEN_MENU_ITEM_MODAL, 'menuItemId' | 'menuEnabled' | 'menuOrderingUrl' | 'menuItemSource'>;

export function openMenuItemModal(menuItemId: number, menuEnabled: boolean = true, menuOrderingUrl: string | null = null, menuItemSource: MenuItemSource = 'menuItemCard') {
  return (dispatch: Dispatch<OpenMenuItemModalAction>) => {
    dispatch({ menuEnabled, menuItemId, menuItemSource, menuOrderingUrl, type: OPEN_MENU_ITEM_MODAL });
  };
}

type CloseMenuItemModalAction = PickActionFromState<DishesState, typeof CLOSE_MENU_ITEM_MODAL>;
export function closeMenuItemModal() {
  return (dispatch: Dispatch<CloseMenuItemModalAction>) => {
    dispatch({ type: CLOSE_MENU_ITEM_MODAL });
  };
}
